<div>
    <div class="row  m-auto pl-3 pr-3 product-details-upper">
        <div class="col-md-6 col-sm-12 text-center">


            <app-product-galary *ngIf="item" [product]="item"
            ></app-product-galary>

        </div>
        <div class="col-md-6 col-sm-12" style="justify-content: center;">
            <app-product-information-qr *ngIf="item" [product]="item"></app-product-information-qr>
        </div>
    </div>


    <!-- info tab -->

</div>
